import { css } from '@emotion/react';

import { su, theme, typography } from '@adflow/frontend/ui-theme';

const gridLayout = '2.25rem 3rem 1fr 3rem';

export const headerVerticalPadding = '0.75rem';
export const columnHeaderHeight = 15;

export const styles = {
	title: css(typography.title, { marginLeft: '1.25rem' }),
	header: css({
		display: 'grid',
		gap: '0.5rem',
		gridTemplateColumns: gridLayout,
		'& > div': typography.label,

		height: columnHeaderHeight,
		paddingRight: '1.25rem',

		position: 'sticky',
		// Checkboxes are stacked over the header without this z-index
		zIndex: 1,
		top: 0,
		backgroundColor: theme.colors.background.form,
	}),
	body: (maxHeight: number) => css({ overflowY: 'auto', maxHeight }),
	bodyRow: css({
		display: 'grid',
		gap: '0.5rem',
		height: '2.25rem',
		gridTemplateColumns: gridLayout,
		paddingRight: '1.25rem',
		'& > div': css({
			display: 'flex',
			alignItems: 'center',
			'& > *': css({ alignSelf: 'center' }),
		}),
	}),
	icon: css({
		color: theme.colors.palettes.delete.main,
	}),
	bodyRowDragging: css(su.shadow, {
		backgroundColor: theme.colors.background.formDarkened,
		transformStyle: 'preserve-3d',
		transform: 'translate3d(0, 0, 1px)',
	}),
	dragHandleContainer: css({
		justifyContent: 'flex-end',
		width: '100%',
	}),
	dragHandle: css(su.textXl, {
		color: theme.colors.text.tableHeader,
		alignSelf: 'center',
		height: '1em',
		width: '1em',
	}),
	columnButton: css({
		color: theme.colors.text.tableHeader,
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
	}),
	floatingColumnButton: (topOffset: number) =>
		css(su.textXl, {
			backgroundColor: theme.colors.background.tableHeader,
			position: 'absolute',
			top: `${topOffset}px`,
			right: '0px',
			zIndex: 1,
			cursor: 'pointer',

			height: '2rem',
			padding: '0.5rem',
			width: '2.25rem',
		}),
	floatingColumnButtonDisabled: css({
		color: '#dddddd',
		cursor: 'default',
	}),
	headerCellArchived: css({ background: '#dddddd66' }),
	checkboxContainer: css({ justifyContent: 'space-around' }),
};
